import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useEventOutcomesCache } from './cache'
import {
  Logger,
  type UnsavedEventOutcome,
  type EventOutcomeData,
  toResponseError,
  type EventOutcomeAddInput,
  type EventOutcomeAddSuccess,
} from '@terros/common'

const logger = new Logger('useAddEventOutcome')

export function useAddEventOutcome(): AddHookResponse<UnsavedEventOutcome, EventOutcomeData> {
  const { addItem } = useEventOutcomesCache()
  const mutation = useTantalimMutation<EventOutcomeAddInput, EventOutcomeAddSuccess>({
    url: '/calendar/outcome/add',
  })

  async function add(unsaved: UnsavedEventOutcome): Promise<EventOutcomeData> {
    try {
      const { outcome } = await mutation.mutateAsync({ outcome: unsaved })
      logger.verbose('add succeeded', outcome)
      addItem(outcome)
      return outcome
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
